import { useRequest } from 'ahooks';
import { RecordInfoRepository } from 'repositories/RecordInfoRepository';

const repository = RecordInfoRepository;
export const useRecordInfo = () => {
  const getRecordInfo = useRequest(repository.getRecordInfo, { manual: true });

  return { getRecordInfo };
};